<script>
  import ComingSoon from './(landing-components)/ComingSoon.svelte'
  import CTA from './(landing-components)/CTA.svelte'
  import FAQ from './(landing-components)/FAQ.svelte'
  import Features from './(landing-components)/Features.svelte'
  import FinalCTA from './(landing-components)/FinalCTA.svelte'
  import Hero from './(landing-components)/Hero.svelte'
  import HowItWorks from './(landing-components)/HowItWorks.svelte'
</script>

<svelte:head>
  <title>AddMeetings | AI Meeting Qualification Platform</title>
  <meta property="og:title" content="AddMeetings | AI Meeting Qualification Platform" />
  <meta property="og:description" content="AI-powered meeting qualification platform that helps you identify and qualify the right meetings for your business." />
  <meta property="og:image" content="https://addmeetings.com/openGraph.png" />
  <meta property="og:url" content="https://addmeetings.com" />
  <meta property="og:type" content="website" />
  <meta name="twitter:card" content="summary_large_image" />
  <meta name="twitter:title" content="AddMeetings | AI Meeting Qualification Platform" />
  <meta name="twitter:description" content="AI-powered meeting qualification platform that helps you identify and qualify the right meetings for your business." />
  <meta name="twitter:image" content="https://addmeetings.com/openGraph.png" />
</svelte:head>

<Hero />
<Features />
<HowItWorks />
<CTA />
<ComingSoon />
<FAQ />
<FinalCTA />
